import 'reflect-metadata'

import { Expose, Transform } from 'class-transformer'

// import { logger } from '../util'

/**
 * Kind of bet being placed
 */
export enum BetKind {
  ALLIN = 'ALLIN',
  BLANK = 'BLANK',
  BET = 'BET',
  CALL = 'CALL',
  CHECK = 'CHECK',
  RAISE = 'RAISE',
  BIGBLIND = 'BIGBLIND',
  SMALLBLIND = 'SMALLBLIND',
  FOLD = 'FOLD'
}

/**
 * A bet in a game with an amount of chips and kind
 */
export class Bet {
  constructor(
    private _amount: number,
    private _kind: BetKind
  ) {}

  @Expose()
  public get amount() {
    return this._amount
  }

  public set amount(value) {
    this._amount = value
  }

  @Expose()
  @Transform(({ value }) => {
    if (value) {
      const transformedKind = BetKind[value.toUpperCase() as keyof typeof BetKind]
      return transformedKind
    }
    return value
  })
  public get kind() {
    return this._kind
  }

  public set kind(value) {
    this._kind = value
  }
}
